module.exports = __webpack_public_path__ + "img/BannerWeb_1.858a5e4c.png";